import { useEffect, useState } from "react";
import { useApi } from "../../hooks/use-api";
import { useNavigate } from "react-router-dom";
import { ROUTE_CHECK_MAIL } from "../../route";
import { useSingleton } from "../../hooks/use-singleton";
import {
  API_SIGN_UP_FILTER_COUNTRIES,
  API_SIGN_UP_V1,
  API_SIGNUP_COUNTRY_CODE,
  apiSignupCity,
  apiSignupState,
} from "../../utils/api-routes";
import { COOKIE_ACCESS_MAIL } from "../../utils/storage-constants";
import { useNotify } from "../../hooks/use-notify";

const DEFAULT_ERROR_STATE = {
  errEmail: "",
  errPhone: "",
  errName: "",
  errCity: "",
  errState: "",
  errCountry: "",
  errAge: "",
  errUsername: "",
  errDob: "",
  errCountryCode: "",
  errAddress1: "",
  errAddress2: "",
  errAddress3: "",
  isClicked: false,
  isValid: false,
};

const useHandler = () => {
  const { get, post } = useApi();
  const { toggleNotify } = useNotify();
  const { updateUserData } = useSingleton();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState({
    email: "",
    name: "",
    phone: "",
    city: "",
    age: "",
    country: "",
    state: "",
    username: "",
    dob: "",
    countryCode: "",
    address1: "",
    address2: "",
    address3: "",
    pincode: "",
  });

  const [countries, setCountries] = useState();
  const [states, setStates] = useState();
  const [cities, setCities] = useState();
  const [countryCodes, setCountryCodes] = useState();
  const [stepper, setStepper] = useState(1);
  const [showCountry, setShowCountry] = useState(false);
  const [searchCountry, setSearchCountry] = useState("");
  const [error, setError] = useState(DEFAULT_ERROR_STATE);

  const {
    email,
    name,
    phone,
    city,
    age,
    country,
    state,
    countryCode,
    username,
    dob,
    address1,
    address2,
    address3,
    pincode,
  } = data;
  const isEmail = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/;
  const textOnlyRegex = /^[A-Za-z\s]+$/;

  const { isClicked } = error;

  const invalidInputRegex = (input, regex) => new RegExp(regex).test(input);

  const onChangeValue = (e) => {
    const { name, value } = e.target;

    setData((prev) => ({ ...prev, [name]: value }));
  };

  const onValidate = (step = stepper) => {
    let errState = {
      ...DEFAULT_ERROR_STATE,
      isValid: true,
      isClicked: true,
    };

    if (step === 1) {
      if (!name.trim()) {
        errState.errName = "Please Enter Name";
        errState.isValid = false;
      } else if (!textOnlyRegex.test(name.trim())) {
        errState.errName = "Name should contain only letters";
        errState.isValid = false;
      }

      if (!invalidInputRegex(email, isEmail)) {
        errState.errEmail = "Please enter valid Email";
        errState.isValid = false;
      }

      if (!phone || phone.length < 10) {
        errState.errPhone = "Please Enter Your PhoneNumber";
        errState.isValid = false;
      }
      // if (!age) {
      //   errState.errAge = "Please Enter your Age";
      //   errState.isValid = false;
      // }

      if (!username) {
        errState.errUsername = "Please Enter your Username";
        errState.isValid = false;
      }

      if (!countryCode) {
        errState.errCountryCode = "Please Select Country Code";
        errState.isValid = false;
      }

      if (!dob) {
        errState.errDob = "Please Enter your DOB";
        errState.isValid = false;
      }
    }

    if (step === 2) {
      if (!address1.trim()) {
        errState.errAddress1 = "Please Enter Address Line 1";
        errState.isValid = false;
      }

      if (!address2.trim()) {
        errState.errAddress2 = "Please Enter Address Line 2";
        errState.isValid = false;
      }

        // if (!address3) {
    //   errState.errAddress3 = "Please Enter your address3";
    //   errState.isValid = false;
    // }

      if (!city.trim()) {
        errState.errCity = "Please Enter your City";
        errState.isValid = false;
      } else if (!textOnlyRegex.test(city.trim())) {
        errState.errCity = "City should contain only letters";
        errState.isValid = false;
      }

      if (!state.trim()) {
        errState.errState = "Please Enter your State";
        errState.isValid = false;
      } else if (!textOnlyRegex.test(state.trim())) {
        errState.errState = "State should contain only letters";
        errState.isValid = false;
      }

      if (!country.trim()) {
        errState.errCountry = "Please Enter your Country";
        errState.isValid = false;
      } else if (!textOnlyRegex.test(country.trim())) {
        errState.errCountry = "Country should contain only letters";
        errState.isValid = false;
      }
    }

    setError(errState);
    return errState;
  };

  const getCountries = async () => {
    try {
      const res = await get(API_SIGN_UP_FILTER_COUNTRIES);
      if (res) {
        setCountries(res?.data?.countries);
      }
    } catch (e) {
      console.log("ERROR COMES FROM GET COUNTRIES", e);
    }
  };
  const getStates = async (country) => {
    try {
      const res = await get(apiSignupState(country));
      if (res) {
        setStates(res?.data);
      }
    } catch (e) {
      console.log("ERROR COMES FROM GET STATES", e);
    }
  };

  const getCities = async (country, state) => {
    try {
      const res = await get(apiSignupCity(country, state));
      if (res) {
        setCities(res?.data);
      }
    } catch (e) {
      console.log("ERROR COMES FROM GET CITIES", e);
    }
  };

  useEffect(() => {
    getCountries();
  }, []);

  // useEffect(() => {
  //   if (country) {
  //     getStates(country);
  //   }
  // }, [country]);

  // useEffect(() => {
  //   if (country && state) {
  //     getCities(country, state);
  //   }
  // }, [country, state]);

  const onSubmit = async () => {
    const { isValid } = onValidate(2);
    if (!isValid) return;
    const payload = {
      email,
      name,
      phone,
      city,
      country,
      state,
      date_of_birth: dob,
      address_line1: address1,
      address_line2: address2,
      address_line3: address3,
      user_name: username,
      countryCode,
      zipcode: pincode,
    };
      setIsLoading(true);

    try {
      const res = await post(API_SIGN_UP_V1, payload);
      if (res) {
        const isExist = res?.data?.exists;
        if (isExist) {
          localStorage.setItem(COOKIE_ACCESS_MAIL, email);
          toggleNotify({
            type: "error",
            title: "Error",
            description: res?.data?.message,
          });
        } else {
          localStorage.setItem(COOKIE_ACCESS_MAIL, email);
          navigate(ROUTE_CHECK_MAIL);
        }
      }
    } catch (e) {
      console.log("ERROR COMES FROM ACCOUNT CREATE API", e);
    } finally {
      setIsLoading(false);
    }
  };

  const getCountryCodes = async () => {
    try {
      const res = await get(API_SIGNUP_COUNTRY_CODE);
      if (res) {
        const { Country, calling_codes } = res?.data;
        const countryList = Country?.map((country, index) => ({
          country: country?.slice(0, 5),
          code: calling_codes[index],
        }));
        setCountryCodes(countryList);
      }
    } catch (e) {
      console.log("ERROR COMES FORM COUNTRYCODE API", e);
    }
  };

  useEffect(() => {
    getCountryCodes();
  }, []);

  return {
    data,
    error,
    countries,
    states,
    cities,
    countryCodes,
    stepper,
    onChangeValue,
    onSubmit,
    navigate,
    setStepper,
    onValidate,
    isLoading
  };
};

export default useHandler;
